<template>
    <div>
        <mml-base-header-sec></mml-base-header-sec>

        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <form class="w-100" v-on:keyup.enter="search">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Речи и изрази у називу</label>
                                <input type="text" v-model="title_query" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Речи и изрази у тексту</label>
                                <input type="text" v-model="text_query" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Врста мишљења и других аката</label>
                                <select v-model="opinion_type" class="form-control full-width">
                                    <option value="-1">Све подврсте мишљења и других аката</option>
                                    <option v-for="item in filters.opinion_types" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm" v-if="filters.opinion_subtypes.length > 0">
                                <label class="form-label">Врста мишљења и других аката</label>
                                <select v-model="opinion_subtype" class="form-control full-width">
                                    <option v-for="item in filters.opinion_subtypes" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Назив доносиоца / Име аутора</label>
                                <select v-model="authority" class="form-control full-width">
                                    <option value="-1">Сви доносиоци</option>
                                    <option v-for="item in filters.authorities" v-bind:key="item.k" :label="item.l"
                                        :value="item.k">{{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm" v-if="filters.subjects.length > 0">
                                <label class="form-label">Материја</label>
                                <select v-model="subject" class="form-control full-width">
                                    <option v-for="item in filters.subjects" v-bind:key="item.k" :label="item.l"
                                        :value="item.k">{{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Ознака / број акта</label>
                                <input type="text" v-model="number" class="form-control full-width">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Основни пропис</label>
                                <input type="text" v-model="primary_regulation" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Чланови</label>
                                <input type="text" v-model="members" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Други прописи</label>
                                <input type="text" v-model="secondary_regulation" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Извор</label>
                                <select v-model="source" class="form-control full-width">
                                    <option value="-1">Сви извори</option>
                                    <option v-for="item in filters.sources" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="row" v-if="source == 1">
                                <div class="col-md-6">
                                    <div class="form-group form-group-sm">
                                        <label class="form-label">Година</label>
                                        <select v-model="year" class="form-control full-width">
                                            <option v-for="item in filters.years" v-bind:key="item" :value="item">
                                                {{ item }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group form-group-sm">
                                        <label class="form-label">Број</label>
                                        <select v-model="issue" class="form-control full-width">
                                            <option v-for="item in filters.issues" v-bind:key="item" :value="item">
                                                {{ item }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group form-group-sm" v-else-if="source > 1">
                                <label class="form-label">{{ subsource_label }}</label>
                                <select v-model="subsource" class="form-control full-width">
                                    <option v-for="item in filters.subsources" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Тип документа</label>
                                <select v-model="document_type" class="form-control full-width">
                                    <option value="0">Актуелни</option>
                                    <option value="1">Архивски</option>
                                </select>
                            </div>

                            <data-picker-mask-component ref="dataPickerMask" @datapiskerDateFromValue="emitedDateFrom"
                                @datapiskerDateToValue="emitedDateTo"></data-picker-mask-component>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="search_size" class="form-label mr-2">Величина резултата</label>
                                <select v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <!--                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search">-->
                            <!--                                <span class="icon-search mr-2"></span>-->
                            <!--                                Претрага-->
                            <!--                            </button>-->

                            <!--                            <button type="button"-->
                            <!--                                    class="btn btn-base-submit text-uppercase mr-3"-->
                            <!--                                    @click="search"-->
                            <!--                            >-->
                            <!--                                <span class="icon-search mr-2"></span>-->
                            <!--                                Претрага-->
                            <!--                            </button>-->
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search"
                                v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-reset text-uppercase" @click="reset">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <result-counter :count="resultSize" :limit="resultLimit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <!--                <sorted-table :values="result"-->
                <!--                              sort="timestamp"-->
                <!--                              dir="desc"-->
                <!--                              class="table  table-striped table-sm table-slglrs"-->
                <!--                              ascIcon="<span> ▲</span>"-->
                <!--                              descIcon="<span> ▼</span>">-->
                <!--                    <thead>-->
                <!--                    <tr>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="type">Подврста</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="authority">Назив доносиоца / Име аутора</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="principalAct">Ознака / број акта</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="timestamp">Датум доношења акта</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="closerDesignation">Ближе одређење материје / назив</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="sourceName">Начин објаве</sort-link>-->
                <!--                        </th>-->
                <!--                    </tr>-->
                <!--                    </thead>-->
                <!--                    <template #body="sort">-->
                <!--                        <tbody>-->
                <!--                        <tr v-for="(item, index) in sort.values" v-bind:key="index">-->
                <!--                            <td>{{item.type}}</td>-->
                <!--                            <td>{{item.authority}}</td>-->
                <!--                            <td>{{item.principalAct}}</td>-->
                <!--                            <td>{{item.date}}</td>-->
                <!--                            <td><a :href="baseUrl +'mml/viewAct/naziv-akta/' + item.id" target="_blank">{{item.closerDesignation}}</a>-->
                <!--                            </td>-->
                <!--                            <td>{{item.sourceName}}</td>-->
                <!--                        </tr>-->
                <!--                        </tbody>-->
                <!--                    </template>-->
                <!--                </sorted-table>-->

                <b-table class="table-bootstrap-vue" striped bordered :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                    :items="result" :fields="fields" responsive="sm">
                    <template v-slot:cell(closerDesignation)="data">
                        <router-link target="_blank" :to="{ path: '/mml/viewAct/' + data.item.id }">{{
                            data.item.closerDesignation
                        }}</router-link>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                        {{ data.item.date }}
                    </template>
                </b-table>



            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import MmlBaseHeaderSec from '@/base_pages/mml/MmlBaseHeaderSec.vue';
// import Datepicker from 'vuejs-datepicker';
import { srCYRL } from 'vuejs-datepicker/dist/locale'
// import {SortedTable, SortLink} from "vue-sorted-table";
import ResultCounter from '@/partials/ResultCounter.vue';
import { mapState } from 'vuex';

import DataPickerMaskComponent from '@/components/DataPickerMaskComponent.vue';

export default {
    name: "MmlStandardSearchPage",
    data() {
        return {

            sortBy: 'timestamp',
            sortDesc: true,
            fields: [
                { label: 'Подврста', key: 'type', sortable: true },
                { label: 'Назив доносиоца / Име аутора', key: 'authority', sortable: true },
                { label: 'Ознака / број акта', key: 'principalAct', sortable: true },
                { label: 'Датум доношења акта', key: 'timestamp', sortable: true },
                { label: 'Ближе одређење материје / назив', key: 'closerDesignation', sortable: true },
                { label: 'Начин објаве', key: 'sourceName', sortable: true },
            ],
            emitedDateFromVal: null,
            emitedDateToVal: null,
            srCYRL: srCYRL,
            isActOpen: false,
            actHTML: '',
            result: [],

            resultSize: null,
            resultLimit: 50,
            baseMMLApiUrl: window.env.VUE_APP_API_MML_DEV,
            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,


            members: '',
            number: '',
            primary_regulation: '',
            secondary_regulation: '',
            title_query: '',
            text_query: '',

            authority: -1,
            opinion_type: -1,
            opinion_subtype: -1,
            source: -1,
            subsource: -1,
            year: null,
            issue: null,

            document_type: 0,
            dateFrom: null,
            dateTo: null,

            filters: {
                authorities: [],
                issues: [],
                opinion_types: [],
                opinion_subtypes: [],
                sources: [],
                subjects: [],
                subsources: [],
                years: [],
            },
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        MmlBaseHeaderSec,
        // Datepicker,
        // SortedTable,
        // SortLink,
        ResultCounter,
        DataPickerMaskComponent
    },
    computed: {
        subsource_param: function () {
            if (this.source == 1) {
                return this.issue + '/' + this.year;
            }
            return null;
        },
        subsource_label: function () {
            for (var i = 0; i < this.filters.sources.length; i++) {
                if (this.filters.sources[i].k == this.source) {
                    console.log(this.filters.sources[i].l);
                    return this.filters.sources[i].l;
                }
            }
            return null;
        },
        disabledDatesFrom: function () {
            if (this.dateTo === null) {
                return { from: new Date }
            } else return { from: this.dateTo }
        },
        disabledDatesTo: function () {
            if (this.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.dateFrom, from: new Date }
        },

        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('LSD')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        emitedDateFrom(e) {
            this.emitedDateFromVal = e;
        },
        emitedDateTo(e) {
            this.emitedDateToVal = e;
        },
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        fetchData() {
            axios.get(this.baseMMLApiUrl + 'prins/opinionSearch/filter?archived=' + (this.document_type == 0 ? 'false' : 'true'))
                .then(response => {
                    this.filters.authorities = response.data.authorityKinds;
                    this.filters.opinion_types = response.data.opinionTypes;

                    this.filters.sources = response.data.sourceKinds;

                    this.reset();

                    if (this.$route.query.q !== undefined) {
                        this.primary_regulation = this.$route.query.q;
                    }
                    if (this.$route.query.article !== undefined) {
                        this.members = this.$route.query.article;
                    }
                });
        },
        search() {

            // // Local DATA
            // let responseLocal = {"limit":50,"resultSize":6723,"result":[{"id":"11195","type":"Извештај","authority":"Комисија за заштиту конкуренције","principalAct":null,"closerDesignation":"Извештај о секторској анализи тржишта трговине на мало дериватима нафте у 2018. години","sourceName":"Вебсајт Комисије","date":"23.12.2019","year":2019},{"id":"11197","type":"Обавештење","authority":"Републички геодетски завод","principalAct":"06 952-1582/2019","closerDesignation":"Документа Републичког геодетског завода – Измене и допуне Закона о Републичким административним таксама","sourceName":"Вебсајт Завода","date":"23.12.2019","year":2019},{"id":"11198","type":"Мишљење","authority":"Министарство грађевинарства, саобраћаја и инфраструктуре","principalAct":"011-00-00728/2019-07","closerDesignation":"Тумачење појединих одредби Закона о посебним условима за реализацију пројекта изградње станова за припаднике снага безбедности које се односе на ослобађање наплате такси","sourceName":"Вебсајт Завода","date":"23.12.2019","year":2019},{"id":"11153","type":"Обавештење","authority":"Министарствo трговине, туризма и телекомуникација","principalAct":null,"closerDesignation":"Обавештење поводом доношења Правилника о садржини и начину подношења пријаве за некатегорисани угоститељски објекат за смештај, некатегорисани објекат за смештај наутичког туризма, некатегорисани објекат за смештај ловног туризма и о садржини и начину вођења евиденције објеката за смештај","sourceName":"Вебсајт Министарства","date":"20.12.2019","year":2019},{"id":"11147","type":"Обавештење","authority":"Министарство државне управе и локалне самоуправе","principalAct":null,"closerDesignation":"Обавештење Министарства државне управе и локалне самоуправе о исплати отпремнина за одлазак у пензију у 2020. години","sourceName":"Вебсајт Министарства","date":"19.12.2019","year":2019},{"id":"11142","type":"План","authority":"Министарство грађевинарства, саобраћаја и инфраструктуре","principalAct":null,"closerDesignation":"Годишњи план расподеле за 2020. годину донет на основу Уредбе о расподели страних дозвола за међународни јавни превоз ствари домаћим превозницима - Прелиминарни општи део плана расподеле дозвола за 2020. годину","sourceName":"Вебсајт Министарства","date":"17.12.2019","year":2019},{"id":"11145","type":"Обавештење","authority":"Пореска управа","principalAct":null,"closerDesignation":"Обавештење Пореске управе о неплаћању административних такси за издавање уверења електронским путем","sourceName":"Вебсајт Управе","date":"17.12.2019","year":2019},{"id":"11143","type":"Обавештење","authority":"Народна банка","principalAct":null,"closerDesignation":"Обавештење Народне банке Србије поводом усвајања измена прописа ради подстицања кредитирања привреде у динарима","sourceName":"Вебсајт Народне банке","date":"16.12.2019","year":2019},{"id":"11152","type":"Обавештење","authority":"Управа царина","principalAct":"148-07-483-01-635/2019","closerDesignation":"Обавештење о примени Инструкције о управљању тарифним квотама","sourceName":"Вебсајт Управе","date":"13.12.2019","year":2019},{"id":"11138","type":"Обавештење","authority":"Управа царина","principalAct":"148-II-353-07-22/2019","closerDesignation":"Обавештење Управе царина о примени Правилника о контроли радиоактивности робе приликом увоза, извоза и транзита („Сл. гласник РС\", бр. 86/19)","sourceName":"Вебсајт Управе","date":"13.12.2019","year":2019},{"id":"11148","type":"Мишљење","authority":"Повереник за заштиту равноправности","principalAct":"011-00-00040/2019-02","closerDesignation":"Мишљење на Нацрт закона о правима бораца, војних инвалида, цивилних инвалида рата и чланова њихових породица","sourceName":"Вебсајт Повереника","date":"12.12.2019","year":2019},{"id":"11150","type":"Предлози и иницијативе","authority":"Повереник за заштиту равноправности","principalAct":"011-00-42/2019-02","closerDesignation":"Иницијатива Повереника за заштиту равноправности за измену јавноизвршитељске тарифе","sourceName":"Вебсајт Повереника","date":"12.12.2019","year":2019},{"id":"11137","type":"Мишљење","authority":"Заштитник грађана","principalAct":"353-71/19","closerDesignation":"Мишљење на нацрт Закона о правима бораца, војних инвалида, цивилних инвалида рата и чланова њихових породица","sourceName":"Вебсајт Заштитника","date":"11.12.2019","year":2019},{"id":"11125","type":"Обавештење","authority":"Агенција за привредне регистре","principalAct":null,"closerDesignation":"Обавештење о електронској регистрацији уговора о финансијском лизингу од 1. јануара 2020. године","sourceName":"Вебсајт Агенције","date":"10.12.2019","year":2019},{"id":"11149","type":"Мишљење","authority":"Повереник за заштиту равноправности","principalAct":"011-00-41/2019-02","closerDesignation":"Мишљење на Нацрт закона о Меморијалном центру „Старо сајмиште“","sourceName":"Вебсајт Повереника","date":"10.12.2019","year":2019},{"id":"11144","type":"Препорукa","authority":"Заштитник грађана","principalAct":"13-37-5655/16","closerDesignation":"Препоруке због пропуста у раду Ловачког удружења услед неблаговременог одлучивања о притужиочевом захтеву за накнаду штете коју му је проузроковала заштићена дивљач","sourceName":"Вебсајт Заштитника","date":"10.12.2019","year":2016},{"id":"11140","type":"Обавештење","authority":"Управа царина","principalAct":"148-II-439-02-22/10/2019","closerDesignation":"Обавештење о почетку реаализације Пилот пројекта \"Унапређење дигитализованог система повраћаја ПДВ путницима'' и поступање са Захтевом за повраћај ПДВ издатим на документу оператора","sourceName":"Вебсајт Управе","date":"09.12.2019","year":2019},{"id":"11141","type":"Обавештење","authority":"Управа царина","principalAct":"148-II-439-439-04-5/2019","closerDesignation":"Обавештење Управе царине о најновијим изменама и допунама Закона о републичким административним таксама","sourceName":"Вебсајт Управе","date":"09.12.2019","year":2019},{"id":"11124","type":"Обавештење","authority":"Републички фонд за пензијско и инвалидско осигурање","principalAct":null,"closerDesignation":"Обавештење Републичког фонда за пензијско и инвалидско осигурање поводом Одлуке о висини трошкова издавања картице здравственог осигурања","sourceName":"Вебсајт Фонда","date":"07.12.2019","year":2019},{"id":"11105","type":"Обавештење","authority":"Повереник за информације од јавног значаја и заштиту података о личности","principalAct":null,"closerDesignation":"Обавештење Повереника за информације од јавног значаја и заштиту података о личности о достављању годишњих извештаја","sourceName":"Вебсајт Повереника","date":"06.12.2019","year":2019},{"id":"11082","type":"Мишљење","authority":"Министарство финансија","principalAct":"430-00-00522/2019-04","closerDesignation":"Основ за ослобођење или умањење пореза за објекте који су руинирани, па их је потребно реновирати ради коришћења за одређену намену","sourceName":"Вебсајт Министарства","date":"03.12.2019","year":2019},{"id":"11151","type":"Мишљење","authority":"Повереник за заштиту равноправности","principalAct":"011-00-38/2019-02","closerDesignation":"Мишљење Повереника за заштиту равноправности на Нацрт закона о изменама и допунама Закона о средњем образовању и васпитању","sourceName":"Вебсајт Повереника","date":"02.12.2019","year":2019},{"id":"11050","type":"Објашњење","authority":"Управа царина","principalAct":"148-I-030-01-482/2019","closerDesignation":"Објашњење поступка царинског складиштења","sourceName":"Вебсајт Управе","date":"21.11.2019","year":2019},{"id":"11051","type":"Објашњење","authority":"Управа царина","principalAct":"148-I-030-01-483/2019","closerDesignation":"Објашњење Управе царина о привременом смештају робе","sourceName":"Вебсајт Управе","date":"21.11.2019","year":2019},{"id":"11053","type":"Објашњење","authority":"Управа царина","principalAct":"148-I-030-01-482/02/2019","closerDesignation":"Објашњење о поновној процени одобрења за држање царинског складишта и простора за привремени смештај","sourceName":"Вебсајт Управе","date":"21.11.2019","year":2019},{"id":"11054","type":"Објашњење","authority":"Управа царина","principalAct":"148-I-030-01-532/2019","closerDesignation":"Објашњење поједностављеног царинског поступка на основу фактуре","sourceName":"Вебсајт Управе","date":"20.11.2019","year":2019},{"id":"11049","type":"Мишљење","authority":"Заштитник грађана","principalAct":"1339-828/2018","closerDesignation":"Мишљење Заштитника грађана поводом висине износа Јавноизвршитељске тарифе","sourceName":"Вебсајт Заштитника","date":"19.11.2019","year":2018},{"id":"11048","type":"Обавештење","authority":"Управа царина","principalAct":"148-II-439-02-22/6/2019","closerDesignation":"Обавштење о захтеву за повраћај ПДВ путнику, издат на документу оператора","sourceName":"Вебсајт Управе","date":"19.11.2019","year":2019},{"id":"11032","type":"Обавештење","authority":"Републички геодетски завод","principalAct":"06 952-1434/2019","closerDesignation":"Документа Републичког геодетског завода – Примена члана 39. Закона о поступку уписа у катастар непокретности и водовима","sourceName":"Вебсајт Завода","date":"13.11.2019","year":2019},{"id":"11045","type":"Обавештење","authority":"Управа царина","principalAct":"148-II-439-02-22/4/2019","closerDesignation":"Обавештење о изменама и допунама Правилника о начину и поступку остваривања пореских ослобођења код ПДВ са правом на одбитак претходног пореза","sourceName":"Вебсајт Управе","date":"12.11.2019","year":2019},{"id":"11020","type":"Објашњење","authority":"Влада, Канцеларија за сарадњу са цивилним друштвом, Министарство државне управе и локалне самоуправе","principalAct":null,"closerDesignation":"Водич за транспарентно финансирање удружења и других организација цивилног друштва из буџетских средстава локалних самоуправа","sourceName":"Вебсајт Канцеларије за сарадњу са цивилним друштвом","date":"08.11.2019","year":2019},{"id":"11022","type":"Обавештење","authority":"Републички геодетски завод","principalAct":"952-1411/2019","closerDesignation":"Документa Републичког геодетског завода – Пријем другостепених решења","sourceName":"Вебсајт Завода","date":"07.11.2019","year":2019},{"id":"10994","type":"Упутство","authority":"Министарство финансија","principalAct":null,"closerDesignation":"Упутство за израду програмског буџета","sourceName":"Вебсајт Министарства","date":"04.11.2019","year":2019},{"id":"11023","type":"Мишљење","authority":"Повереник за заштиту равноправности","principalAct":"1171/2019","closerDesignation":"Мишљење Повереника за заштиту равноправности на Нацрт закона о здравственој заштити и здравственом осигурању војних осигураника","sourceName":"Вебсајт Повереника","date":"04.11.2019","year":2019},{"id":"11025","type":"Препорукa","authority":"Заштитник грађана","principalAct":"13-22-3212/18","closerDesignation":"Препоруке због пропуста у раду Министарства за заштиту животне средине и Градске управе услед неспровођења ефикасног инспекцијског надзора и правовременог отклањања загађења ваздуха","sourceName":"Вебсајт Заштитника","date":"04.11.2019","year":2018},{"id":"11026","type":"Мишљење","authority":"Заштитник грађана","principalAct":"353-56/2019","closerDesignation":"Мишљење Заштитника грађана на Нацрт Закона о здравственој заштити и здравственом осигурању војних осигураника","sourceName":"Вебсајт Заштитника","date":"04.11.2019","year":2019},{"id":"10988","type":"Мишљење","authority":"Заштитник грађана","principalAct":"322-196/19","closerDesignation":"Мишљење са препорукама због пропуста у раду Комесаријата за избеглице и миграције и Прихватног центра услед непредузимања одговарајућих мера поводом пријављених навода кориснице","sourceName":"Вебсајт Заштитника","date":"01.11.2019","year":2019},{"id":"10989","type":"Обавештење","authority":"Агенција за привредне регистре","principalAct":null,"closerDesignation":"Обавештење Агенције за привредне регистре о пријави и одјави предузетника из евиденције обвезника достављања финансијских извештаја за 2019. годину","sourceName":"Вебсајт Агенције","date":"01.11.2019","year":2019},{"id":"10993","type":"Смерницe","authority":"Организација за економску сарадњу и развој","principalAct":null,"closerDesignation":"Смернице за борбу против намештања понуда у јавним набавкама","sourceName":"Вебсајт Комисије","date":"01.11.2019","year":2019},{"id":"10996","type":"Мишљење","authority":"Заштитник грађана","principalAct":"4210-23/2019","closerDesignation":"Мишљење са препорукама због пропуста у раду Инспектората за рад – Одељења инспекције рада услед непредузимања мера из своје надлежности у циљу спречавања и отклањања повреда радноправних прописа","sourceName":"Вебсајт Заштитника","date":"31.10.2019","year":2019},{"id":"11196","type":"Мишљење","authority":"Министарство финансија","principalAct":"011-00-00663/2019-04","closerDesignation":"Мишљење у вези опредељивања таксене обавезе по захтевима поднетим од стране Дирекције за грађевинско земљиште и изградњу Београда ЈП Републичком геодетском заводу за издавање одређених списа, односно вршења радњи, којима се накнадно придружио Секретаријат за комуналне и стамбене послове Града Београда","sourceName":"Вебсајт Завода","date":"31.10.2019","year":2019},{"id":"11091","type":"Мишљење","authority":"Министарство финансија","principalAct":"011-00-00804/2019-04","closerDesignation":"Плаћање годишње накнаде за коришћење радио- фреквенција за иницијалну 5С мрежу у Научно-технолошком парку Звездара","sourceName":"Вебсајт Министарства","date":"30.10.2019","year":2019},{"id":"10991","type":"Мишљење","authority":"Комисија за хартије од вредности","principalAct":"4/1-102-1447/6-19","closerDesignation":"Остало - мишљење Комисије за хартије од вредности поводом питања о примени чл. 2, 9, 12. и 39. Закона о тржишту капитала","sourceName":"Правно - информациони систем Републике Србије","date":"29.10.2019","year":2019},{"id":"11090","type":"Мишљење","authority":"Министарство финансија","principalAct":"430-00-00520/2019-04","closerDesignation":"Опредељивање таксене обавезе по захтевима поднетим од стране Дирекције за грађевинско земљиште и изградњу Београда ЈП имајући у виду одредбе чл. 3. и 18. Закона о републичким административним таксама","sourceName":"Вебсајт Министарства","date":"29.10.2019","year":2019},{"id":"11060","type":"Мишљење","authority":"Министарство финансија","principalAct":"011-00-773/2019-04","closerDesignation":"Право на пореско ослобођење у случају промета добара и услуга који се врши у циљу реализације Пројекта „Модернизација техничко-путничке станице Земун – фаза 1\", а на основу Уговора о зајму између Акционарског друштва за железнички превоз путника „Србија Воз\" Београд (корисник зајма) и Европске банке за обнову и развој (ЕБРД) за који је Република Србија гарант","sourceName":"Вебсајт Министарства","date":"28.10.2019","year":2019},{"id":"11061","type":"Мишљење","authority":"Министарство финансија","principalAct":"430-00-00532/2019-04","closerDesignation":"Порески третман промета услуге у случају када на основу закљученог уговора обвезник ПДВ „А\" од обвезника ПДВ „Б\" стекне право на дистрибуцију телевизијског програма на територији друге државе, па после извесног времена у којем није реализовао промет услуга дистрибуције телевизијског програма закључи уговор са страним привредним друштвом на основу којег том страном привредном друштву уступи уговор којим је стекао право на дистрибуцију телевизијског програма, на који се сагласио обвезник ПДВ „Б\"","sourceName":"Вебсајт Министарства","date":"28.10.2019","year":2019},{"id":"11062","type":"Мишљење","authority":"Министарство финансија","principalAct":"430-00-530/2019-04","closerDesignation":"Право на одбитак претходног пореза за промет услуга које се односе на отклањање последица штетног догађаја у случају када се уговором о ускладиштењу обвезник ПДВ - складиштар обавеже да ће осигурати добра примљена на чување и да ће у случају настанка штетног догађаја са последицама на тим добрима иста вратити у пређашње стање о свом трошку, а ако повраћај у пређашње стање није могућ да ће власнику добара надокнадити потпуну штету, па у току уговора о ускладиштењу дође до штетног догађаја и настанка уговорне обавезе обвезника ПДВ – складиштара да добра врати у пређашње стање","sourceName":"Вебсајт Министарства","date":"28.10.2019","year":2019},{"id":"11064","type":"Мишљење","authority":"Министарство финансија","principalAct":"011-00-713/2019-04","closerDesignation":"Порески третман промета у случају када обвезник ПДВ на основу уговора о испоруци готових производа у иностранство којим је уговорена и обавеза израде алата који служи изради тих готових производа, изврши промет готових производа и алата наручиоцу посла, с тим да се готови производи отпремају у иностранство, а алат остаје у Републици Србији","sourceName":"Вебсајт Министарства","date":"28.10.2019","year":2019},{"id":"11063","type":"Мишљење","authority":"Министарство финансија","principalAct":"011-00-00515/2019-04","closerDesignation":"Oсновицa за обрачунавање ПДВ за промет природног гаса","sourceName":"Вебсајт Министарства","date":"28.10.2019","year":2019},{"id":"10981","type":"Упутство","authority":"Републички геодетски завод","principalAct":null,"closerDesignation":"Корисничко упутство за геодетске организације","sourceName":"Вебсајт Завода","date":"25.10.2019","year":2019}]};
            // this.result = responseLocal.result;
            // this.resultSize = responseLocal.resultSize;
            // for (var i = 0; i < this.result.length; i++) {
            //     this.result[i].timestamp = moment(this.result[i].date, 'DD.MM.YYYY').valueOf();
            // }



            const vm = this;
            var url = this.baseDIApiUrl + 'mml/opinionSearch';
            var data = {
                aai: this.subject,
                aki: this.authority,
                aln: (this.number == '') ? null : this.number,
                ami: this.opinion_subtype,
                ampi: this.opinion_type,
                ar: this.document_type,
                // df: this.dateFrom,
                // dt: this.dateTo,

                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,
                limit: this.resultLimit,
                oa: (this.secondary_regulation == '') ? null : this.secondary_regulation,
                pa: (this.primary_regulation == '') ? null : this.primary_regulation,
                paa: (this.members == '') ? null : this.members,
                sid: this.subsource,
                ski: this.source,
                src: this.subsource_param,
                bk: (this.text_query == '') ? null : this.text_query,
                tk: (this.title_query == '') ? null : this.title_query,
            };
            axios.post(url, data)
                .then(response => {
                    var data = response.data.result;

                    for (var i = 0; i < data.length; i++) {
                        data[i].timestamp = moment(data[i].date, 'DD.MM.YYYY').valueOf();
                    }

                    this.result = data;
                    this.resultSize = response.data.resultSize;
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        // nije ulogovan
                        // otvori modal za logovanje
                        vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                    }
                });

        },
        reset() {
            this.authority = -1;
            this.opinion_type = -1;
            this.source = -1;
            this.subsource = -1;
            this.issue = null;

            this.members = '';
            this.number = '';
            this.primary_regulation = '';
            this.secondary_regulation = '';
            this.title_query = '';
            this.text_query = '';

            this.dateFrom = null;
            this.dateTo = null;
            this.emitedDateFromVal = null;
            this.emitedDateToVal = null;

            this.resultLimit = 50;

            this.result = [];
            this.resultSize = null;
            this.$refs.dataPickerMask.resetDate();
        },
        fetchYears() {
            axios.get(this.baseMMLApiUrl + 'prins/gazette/years/1')
                .then(response => {
                    this.filters.years = response.data;
                    if (this.filters.years.length > 0) {
                        this.year = this.filters.years[0];
                        this.fetchIssues(this.filters.years[0]);
                    }
                });
        },
        fetchIssues(year) {
            axios.get(this.baseMMLApiUrl + 'prins/gazette/numbers/1/' + year)
                .then(response => {
                    this.filters.issues = response.data;
                    if (this.filters.issues.length > 0) {
                        this.issue = this.filters.issues[0];
                    }
                })
        },
        fetchSubsources(url) {
            axios.get(this.baseMMLApiUrl + url)
                .then(response => {
                    this.filters.subsources = response.data;
                });
        }
    },
    watch: {
        document_type: function () {
            this.fetchData();
        },
        opinion_type: function () {
            this.opinion_subtype = -1;
            axios.get(this.baseMMLApiUrl + 'prins/types/' + this.opinion_type + '?archived=' + (this.document_type == 0 ? 'false' : 'true'))
                .then(response => {
                    this.filters.opinion_subtypes = response.data;
                    console.log(this.filters.opinion_subtypes.length);
                })
        },
        authority: function () {
            this.subject = -1;
            axios.get(this.baseMMLApiUrl + 'prins/authorityArea/1/' + this.authority + '?archived=' + (this.document_type == 0 ? 'false' : 'true'))
                .then(response => {
                    this.filters.subjects = response.data;
                })
        },
        year: function () {
            this.fetchIssues(this.year);
        },
        source: function () {
            switch (this.source) {
                case 1:
                    this.fetchYears();
                    break;
                case 5:
                    this.fetchSubsources('prins/websites/1');
                    break;
                case 6:
                    this.fetchSubsources('prins/glasnikIssues/1');
                    break;
                case 24:
                    this.fetchSubsources('prins/otherIssues/1');
                    break;
                default:
                    break;
            }

            if (this.filters.subsources.length > 0) {
                this.subsource = this.filters.subsources[0].k;
            }

            if (this.filters.years.length > 0) {
                this.year = this.filters.years[0];
            }

            if (this.filters.issues.length > 0) {
                this.issue = this.filters.issues[0];
            }
        },
        resultLimit: function () {
            this.resultSize = null;
        }
    },
    created() {
        this.fetchData();
    },
    beforeCreate: function () {
        document.body.className = 'color_mml';
    }
}
</script>

<style>
.date_input_1 {
    display: none;
}

.table-bootstrap-vue thead tr th:nth-child(1) {
    width: 10%;
}

.table-bootstrap-vue thead tr th:nth-child(2) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(3) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(4) {
    width: 10%;
}

.table-bootstrap-vue thead tr th:nth-child(5) {
    width: 40%;
}

.table-bootstrap-vue thead tr th:nth-child(6) {
    width: 10%;
}
</style>
